<template>
  <div class="animated fadeIn">
    <!-- Cabeçalho -->
    <b-row>
      <b-col cols="12">
        <b-button
          variant="link"
          class="px-0 mb-3"
          @click="$router.push('/ead/cursos')"
        >
          <i class="fa fa-arrow-left mr-2"></i>
          Voltar para Cursos
        </b-button>
        <h2 class="mb-4">
          Configurar Curso: {{ course ? course.nome : "Carregando..." }}
        </h2>
      </b-col>
    </b-row>

    <!-- Loading inicial -->
    <div v-if="initialLoading" class="text-center py-5">
      <b-spinner variant="primary" label="Carregando..."></b-spinner>
      <p class="mt-3 text-muted">Carregando informações do curso...</p>
    </div>

    <!-- Conteúdo principal -->
    <div v-else-if="course">
      <!-- Tabs de navegação -->
      <b-card no-body>
        <b-tabs v-model="currentTab" card>
          <!-- TAB 1: Informações do Curso -->
          <b-tab title="Informações do Curso">
            <b-card-body>
              <b-form @submit.prevent="saveCourse">
                <b-row>
                  <b-col md="8">
                    <b-form-group
                      label="Nome do Curso"
                      label-for="nome"
                      label-cols-md="3"
                    >
                      <b-form-input
                        id="nome"
                        v-model="courseForm.nome"
                        required
                        placeholder="Ex: Desenvolvimento Web Completo"
                      ></b-form-input>
                    </b-form-group>

                    <b-form-group
                      label="Subtítulo"
                      label-for="subtitulo"
                      label-cols-md="3"
                    >
                      <b-form-input
                        id="subtitulo"
                        v-model="courseForm.subtitulo"
                        required
                        placeholder="Ex: Aprenda HTML, CSS, JavaScript..."
                      ></b-form-input>
                    </b-form-group>

                    <b-form-group
                      label="Descrição"
                      label-for="descricao"
                      label-cols-md="3"
                    >
                      <b-form-textarea
                        id="descricao"
                        v-model="courseForm.descricao"
                        rows="4"
                        required
                        placeholder="Descrição detalhada do curso..."
                      ></b-form-textarea>
                    </b-form-group>

                    <b-form-group
                      label="URL da Imagem"
                      label-for="imagem"
                      label-cols-md="3"
                    >
                      <b-form-input
                        id="imagem"
                        v-model="courseForm.imagem"
                        type="url"
                        required
                        placeholder="https://exemplo.com/imagem.jpg"
                      ></b-form-input>
                    </b-form-group>

                    <b-form-group
                      label="Categoria"
                      label-for="categoria"
                      label-cols-md="3"
                    >
                      <b-form-select
                        id="categoria"
                        v-model="courseForm.categoria"
                        :options="categorias"
                        required
                      ></b-form-select>
                    </b-form-group>

                    <b-form-group
                      label="Tags"
                      label-for="tags"
                      label-cols-md="3"
                      description="Digite as tags e pressione Enter"
                    >
                      <b-form-tags
                        id="tags"
                        v-model="courseForm.tags"
                        placeholder="Ex: JavaScript, React, Node.js"
                        tag-variant="primary"
                        tag-pills
                      ></b-form-tags>
                    </b-form-group>

                    <b-form-group
                      label="Validade do Certificado"
                      label-for="certificateValidity"
                      label-cols-md="3"
                      description="Período de validade do certificado após conclusão"
                    >
                      <b-form-select
                        id="certificateValidity"
                        v-model="courseForm.certificateValidity"
                        :options="validityOptions"
                        required
                      ></b-form-select>
                    </b-form-group>
                  </b-col>

                  <b-col md="4">
                    <b-form-group label="Preview da Imagem">
                      <b-img
                        v-if="courseForm.imagem"
                        :src="courseForm.imagem"
                        fluid
                        rounded
                        alt="Preview do curso"
                        @error="imageError = true"
                      ></b-img>
                      <b-alert
                        v-if="imageError && courseForm.imagem"
                        variant="warning"
                        show
                        class="mt-2"
                      >
                        <i class="fa fa-exclamation-triangle"></i>
                        Não foi possível carregar a imagem.
                      </b-alert>
                    </b-form-group>
                  </b-col>
                </b-row>

                <hr />
                <div class="text-right">
                  <b-button type="submit" variant="primary" :disabled="loading">
                    <b-spinner v-if="loading" small class="mr-1"></b-spinner>
                    <i v-else class="fa fa-save mr-1"></i>
                    Salvar Alterações
                  </b-button>
                </div>
              </b-form>
            </b-card-body>
          </b-tab>

          <!-- TAB 2: Módulos e Conteúdos -->
          <b-tab title="Módulos e Conteúdos">
            <b-card-body class="p-0">
              <b-row no-gutters>
                <!-- COLUNA ESQUERDA: MÓDULOS -->
                <b-col md="5" class="border-right module-column">
                  <div class="p-3 bg-light border-bottom">
                    <div
                      class="d-flex justify-content-between align-items-center"
                    >
                      <h5 class="mb-0">
                        <i class="fa fa-list mr-2"></i>Módulos
                      </h5>
                      <b-button
                        size="sm"
                        variant="primary"
                        @click="openModuleModal()"
                      >
                        <i class="fa fa-plus mr-1"></i>
                        Novo Módulo
                      </b-button>
                    </div>
                  </div>

                  <div class="module-list">
                    <div v-if="modulesLoading" class="text-center py-5">
                      <b-spinner small></b-spinner>
                    </div>

                    <div
                      v-else-if="modules.length === 0"
                      class="text-center py-5"
                    >
                      <i class="fa fa-folder-open fa-3x text-muted mb-3"></i>
                      <p class="text-muted">Nenhum módulo criado</p>
                      <b-button
                        size="sm"
                        variant="primary"
                        @click="openModuleModal()"
                      >
                        Criar Primeiro Módulo
                      </b-button>
                    </div>

                    <div
                      v-else
                      v-for="(module, index) in modules"
                      :key="module._id"
                      class="module-item"
                      :class="{
                        active:
                          selectedModule && selectedModule._id === module._id,
                      }"
                      @click="selectModule(module)"
                    >
                      <div class="module-content">
                        <div class="module-header">
                          <div class="d-flex align-items-center">
                            <b-badge
                              variant="primary"
                              class="mr-2 module-badge"
                            >
                              {{ index + 1 }}
                            </b-badge>
                            <strong class="module-title">{{
                              module.titulo
                            }}</strong>
                          </div>
                          <div v-if="module.isExam">
                            <b-badge variant="danger" class="ml-2">
                              <i class="fa fa-file-text mr-1"></i>
                              Prova Final
                            </b-badge>
                          </div>
                        </div>
                        <p class="module-description mb-1">
                          {{ module.descricao }}
                        </p>
                        <div class="module-actions" @click.stop>
                          <b-button
                            size="sm"
                            variant="link"
                            class="p-1"
                            @click="openModuleModal(module)"
                            v-b-tooltip.hover
                            title="Editar"
                          >
                            <i class="fa fa-edit"></i>
                          </b-button>
                          <b-button
                            size="sm"
                            variant="link"
                            class="p-1 text-danger"
                            @click="confirmDeleteModule(module)"
                            v-b-tooltip.hover
                            title="Deletar"
                          >
                            <i class="fa fa-trash"></i>
                          </b-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-col>

                <!-- COLUNA DIREITA: CONTEÚDOS -->
                <b-col md="7" class="content-column">
                  <div class="p-3 bg-light border-bottom">
                    <div
                      class="d-flex justify-content-between align-items-center"
                    >
                      <h5 class="mb-0">
                        <i class="fa fa-file mr-2"></i>
                        {{
                          selectedModule
                            ? `Conteúdos: ${selectedModule.titulo}`
                            : "Conteúdos"
                        }}
                      </h5>
                      <b-button
                        v-if="selectedModule"
                        size="sm"
                        variant="success"
                        @click="openContentModal()"
                      >
                        <i class="fa fa-plus mr-1"></i>
                        Novo Conteúdo
                      </b-button>
                    </div>
                  </div>

                  <div class="content-list">
                    <div v-if="!selectedModule" class="text-center py-5">
                      <i class="fa fa-arrow-left fa-3x text-muted mb-3"></i>
                      <p class="text-muted">
                        Selecione um módulo à esquerda para ver seus conteúdos
                      </p>
                    </div>

                    <div v-else-if="contentsLoading" class="text-center py-5">
                      <b-spinner small></b-spinner>
                    </div>

                    <div
                      v-else-if="contents.length === 0"
                      class="text-center py-5"
                    >
                      <i class="fa fa-file-o fa-3x text-muted mb-3"></i>
                      <p class="text-muted">Nenhum conteúdo neste módulo</p>
                      <b-button
                        size="sm"
                        variant="success"
                        @click="openContentModal()"
                      >
                        Criar Primeiro Conteúdo
                      </b-button>
                    </div>

                    <b-table
                      v-else
                      :items="contents"
                      :fields="contentFields"
                      :tbody-tr-class="contentRowClass"
                      thead-class="contents-header"
                      striped
                      hover
                      responsive
                      show-empty
                      class="mb-0 contents-table"
                    >
                      <template #cell(ordem)="data">
                        <b-badge variant="primary" class="ordem-badge">{{
                          data.value + 1
                        }}</b-badge>
                      </template>

                      <template #cell(tipo)="data">
                        <b-badge
                          :variant="getContentTypeVariant(data.value)"
                          class="tipo-badge"
                        >
                          <i
                            :class="getContentTypeIcon(data.value)"
                            class="mr-1"
                          ></i>
                          {{ data.value }}
                        </b-badge>
                      </template>

                      <template #cell(titulo)="data">
                        <strong class="content-title">{{ data.value }}</strong>
                      </template>

                      <template #cell(duracao)="data">
                        <span v-if="data.value" class="duration-text">{{
                          data.value
                        }}</span>
                        <span v-else class="text-muted">-</span>
                      </template>

                      <template #cell(actions)="data">
                        <b-button
                          size="sm"
                          variant="link"
                          class="p-1 action-btn"
                          @click="openContentModal(data.item)"
                          v-b-tooltip.hover
                          title="Editar"
                        >
                          <i class="fa fa-edit action-icon"></i>
                        </b-button>
                        <b-button
                          size="sm"
                          variant="link"
                          class="p-1 action-btn"
                          @click="confirmDeleteContent(data.item)"
                          v-b-tooltip.hover
                          title="Deletar"
                        >
                          <i class="fa fa-trash action-icon text-danger"></i>
                        </b-button>
                      </template>

                      <template #empty>
                        <div class="text-muted text-center py-4">
                          <i class="fa fa-file-o fa-2x mb-2"></i>
                          <p>Nenhum conteúdo encontrado</p>
                        </div>
                      </template>
                    </b-table>
                  </div>
                </b-col>
              </b-row>
            </b-card-body>
          </b-tab>
        </b-tabs>
      </b-card>
    </div>

    <!-- Modal de Módulo -->
    <b-modal
      v-model="moduleModalVisible"
      :title="editingModule ? 'Editar Módulo' : 'Adicionar Módulo'"
      size="lg"
      @hidden="resetModuleForm"
      @ok="saveModule"
      ok-title="Salvar"
      cancel-title="Cancelar"
      :ok-disabled="loading"
    >
      <b-form @submit.prevent="saveModule">
        <b-form-group
          label="Título do Módulo"
          label-for="module-titulo"
          description="Nome do módulo"
        >
          <b-form-input
            id="module-titulo"
            v-model="moduleForm.titulo"
            required
            placeholder="Ex: Introdução ao React"
          ></b-form-input>
        </b-form-group>

        <b-form-group
          label="Descrição"
          label-for="module-descricao"
          description="Breve descrição do que será abordado"
        >
          <b-form-textarea
            id="module-descricao"
            v-model="moduleForm.descricao"
            rows="3"
            required
            placeholder="Descreva o conteúdo do módulo..."
          ></b-form-textarea>
        </b-form-group>

        <b-form-group
          label="Ordem"
          label-for="module-ordem"
          description="Deixe em branco para adicionar ao final"
        >
          <b-form-input
            id="module-ordem"
            v-model="moduleForm.ordem"
            type="number"
            min="0"
            placeholder="0, 1, 2..."
          ></b-form-input>
        </b-form-group>

        <b-form-group>
          <b-form-checkbox v-model="moduleForm.isExam" switch>
            <strong>Este módulo é uma Prova Final</strong>
            <br />
            <small class="text-muted"
              >Marque se este módulo representa uma avaliação final do
              curso</small
            >
          </b-form-checkbox>
        </b-form-group>

        <b-form-group
          v-if="moduleForm.isExam"
          label="Selecione a Prova"
          label-for="module-exam"
          description="Escolha uma prova cadastrada no sistema"
        >
          <b-form-select
            id="module-exam"
            v-model="moduleForm.examId"
            :options="examOptions"
            required
          >
            <template #first>
              <b-form-select-option :value="null" disabled
                >-- Selecione uma prova --</b-form-select-option
              >
            </template>
          </b-form-select>
        </b-form-group>
      </b-form>
    </b-modal>

    <!-- Modal de Conteúdo -->
    <b-modal
      v-model="contentModalVisible"
      :title="editingContent ? 'Editar Conteúdo' : 'Adicionar Conteúdo'"
      size="lg"
      @hidden="resetContentForm"
      @ok="saveContent"
      ok-title="Salvar"
      cancel-title="Cancelar"
      :ok-disabled="loading"
    >
      <b-form @submit.prevent="saveContent">
        <b-form-group label="Tipo de Conteúdo" label-for="content-tipo">
          <b-form-radio-group
            id="content-tipo"
            v-model="contentForm.tipo"
            :options="tiposConteudo"
            @change="handleContentTypeChange"
            buttons
            button-variant="outline-primary"
            class="mb-3"
          ></b-form-radio-group>
        </b-form-group>

        <!-- Campo de Quiz (se tipo = Quiz) -->
        <b-form-group
          v-if="contentForm.tipo === 'Quiz'"
          label="Selecione o Quiz"
          label-for="content-quiz"
          description="Escolha um quiz cadastrado no sistema"
        >
          <b-form-select
            id="content-quiz"
            v-model="contentForm.quizId"
            :options="quizOptions"
            required
          >
            <template #first>
              <b-form-select-option :value="null" disabled
                >-- Selecione um quiz --</b-form-select-option
              >
            </template>
          </b-form-select>
        </b-form-group>

        <b-form-group
          label="Título"
          label-for="content-titulo"
          description="Nome do conteúdo"
        >
          <b-form-input
            id="content-titulo"
            v-model="contentForm.titulo"
            required
            placeholder="Ex: Introdução aos Componentes"
          ></b-form-input>
        </b-form-group>

        <b-form-group
          label="Descrição"
          label-for="content-descricao"
          description="Breve descrição do conteúdo"
        >
          <b-form-textarea
            id="content-descricao"
            v-model="contentForm.descricao"
            rows="2"
            placeholder="Descreva o conteúdo..."
          ></b-form-textarea>
        </b-form-group>

        <b-row>
          <b-col md="8">
            <b-form-group
              v-if="contentForm.tipo === 'Vídeo'"
              label="Video ID SmartPlayer"
              label-for="content-video-id"
              description="Informe o identificador usado no embed do SmartPlayer"
            >
              <b-form-input
                id="content-video-id"
                v-model="contentForm.videoId"
                placeholder="fe8eb7a757db7e33d626111669db788c6bd767dc"
                required
              ></b-form-input>
            </b-form-group>
            <b-form-group
              v-else-if="
                contentForm.tipo !== 'Texto' && contentForm.tipo !== 'Quiz'
              "
              label="URL / Link"
              label-for="content-url"
              :description="getUrlDescription()"
            >
              <b-form-input
                id="content-url"
                v-model="contentForm.url"
                type="url"
                :placeholder="getUrlPlaceholder()"
              ></b-form-input>
            </b-form-group>
          </b-col>

          <b-col md="4">
            <b-form-group
              label="Duração"
              label-for="content-duracao"
              description="Ex: 10:30"
            >
              <b-form-input
                id="content-duracao"
                v-model="contentForm.duracao"
                placeholder="10:30"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <b-form-group
          v-if="contentForm.tipo === 'Texto'"
          label="Conteúdo (Texto)"
          label-for="content-conteudo"
        >
          <b-form-textarea
            id="content-conteudo"
            v-model="contentForm.conteudo"
            rows="6"
            placeholder="Digite o conteúdo do texto..."
          ></b-form-textarea>
        </b-form-group>

        <b-form-group
          label="Ordem"
          label-for="content-ordem"
          description="Deixe em branco para adicionar ao final"
        >
          <b-form-input
            id="content-ordem"
            v-model="contentForm.ordem"
            type="number"
            min="0"
            placeholder="0, 1, 2..."
          ></b-form-input>
        </b-form-group>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import {
  getCourse,
  updateCourse,
  getModules,
  createModule,
  updateModule,
  deleteModule,
  getContents,
  createContent,
  updateContent,
  deleteContent,
  getAllQuizzes,
  getAllExams,
} from "@/api/ead";

export default {
  name: "ConfigurarCurso",
  data() {
    return {
      courseId: null,
      course: null,
      initialLoading: true,
      loading: false,
      imageError: false,
      currentTab: 0,

      // Curso
      courseForm: {
        nome: "",
        subtitulo: "",
        descricao: "",
        imagem: "",
        categoria: "",
        tags: [],
        certificateValidity: "lifetime",
      },

      categorias: [
        { value: "", text: "Selecione uma categoria" },
        { value: "Programação", text: "Programação" },
        { value: "Design", text: "Design" },
        { value: "Marketing", text: "Marketing" },
        { value: "Negócios", text: "Negócios" },
        { value: "Desenvolvimento Pessoal", text: "Desenvolvimento Pessoal" },
        { value: "Fotografia", text: "Fotografia" },
        { value: "Música", text: "Música" },
        { value: "Idiomas", text: "Idiomas" },
        { value: "Outro", text: "Outro" },
      ],

      validityOptions: [
        { value: "3_months", text: "3 meses" },
        { value: "6_months", text: "6 meses" },
        { value: "1_year", text: "1 ano" },
        { value: "lifetime", text: "Vitalício" },
      ],

      // Módulos
      modules: [],
      modulesLoading: false,
      selectedModule: null,
      moduleModalVisible: false,
      editingModule: null,
      moduleForm: {
        titulo: "",
        descricao: "",
        ordem: null,
        isExam: false,
        examId: null,
      },

      // Conteúdos
      contents: [],
      contentsLoading: false,
      contentModalVisible: false,
      editingContent: null,
      contentForm: {
        tipo: "Vídeo",
        titulo: "",
        descricao: "",
        videoId: "",
        url: "",
        conteudo: "",
        duracao: "",
        ordem: null,
        quizId: null,
      },

      tiposConteudo: [
        { text: "Vídeo", value: "Vídeo" },
        { text: "Texto", value: "Texto" },
        { text: "Quiz", value: "Quiz" },
        { text: "Material", value: "Material" },
        { text: "PDF", value: "PDF" },
        { text: "Link", value: "Link" },
      ],

      contentFields: [
        { key: "ordem", label: "#", class: "text-center" },
        { key: "tipo", label: "Tipo" },
        { key: "titulo", label: "Título" },
        { key: "duracao", label: "Duração" },
        { key: "actions", label: "Ações", class: "text-center" },
      ],

      // Quizzes e Provas
      quizzes: [],
      exams: [],
    };
  },

  created() {
    this.syncTabFromRoute();
  },

  computed: {
    quizOptions() {
      return this.quizzes.map((quiz) => ({
        value: quiz._id,
        text: `${quiz.title} (${
          quiz.questions ? quiz.questions.length : 0
        } perguntas)`,
      }));
    },

    examOptions() {
      return this.exams.map((exam) => ({
        value: exam._id,
        text: `${exam.title} (${
          exam.questions ? exam.questions.length : 0
        } perguntas)`,
      }));
    },
  },

  mounted() {
    this.courseId = this.$route.params.id;
    this.loadInitialData();
  },

  watch: {
    "$route.query.tab"() {
      this.syncTabFromRoute();
    },
  },

  methods: {
    syncTabFromRoute() {
      this.currentTab = this.$route.query.tab === "modules" ? 1 : 0;
    },

    async loadInitialData() {
      this.initialLoading = true;
      try {
        await Promise.all([
          this.loadCourse(),
          this.loadModules(),
          this.loadQuizzes(),
          this.loadExams(),
        ]);
      } catch (error) {
        console.error("Erro ao carregar dados iniciais:", error);
        this.$bvToast.toast("Erro ao carregar dados do curso", {
          title: "Erro",
          toastClass: "custom-toast custom-toast-error",
          variant: "light",
          solid: true,
          autoHideDelay: 10000,
          noCloseButton: false,
        });
      } finally {
        this.initialLoading = false;
      }
    },

    async loadCourse() {
      try {
        const response = await getCourse(this.courseId);
        this.course = response.data;
        this.courseForm = {
          nome: this.course.nome,
          subtitulo: this.course.subtitulo,
          descricao: this.course.descricao,
          imagem: this.course.imagem,
          categoria: this.course.categoria,
          tags: this.course.tags || [],
          certificateValidity: this.course.certificateValidity || "lifetime",
        };
      } catch (error) {
        console.error("Erro ao carregar curso:", error);
        throw error;
      }
    },

    async saveCourse() {
      this.loading = true;
      try {
        await updateCourse(this.courseId, this.courseForm);
        this.$bvToast.toast("Curso atualizado com sucesso!", {
          title: "Sucesso",
          toastClass: "custom-toast custom-toast-success",
          variant: "light",
          solid: true,
          autoHideDelay: 5000,
          noCloseButton: false,
        });
        await this.loadCourse();
      } catch (error) {
        console.error("Erro ao salvar curso:", error);
        this.$bvToast.toast("Erro ao atualizar curso", {
          title: "Erro",
          toastClass: "custom-toast custom-toast-error",
          variant: "light",
          solid: true,
          autoHideDelay: 10000,
          noCloseButton: false,
        });
      } finally {
        this.loading = false;
      }
    },

    // ==================== MÓDULOS ====================

    async loadModules() {
      this.modulesLoading = true;
      try {
        const response = await getModules(this.courseId);
        this.modules = response.data || [];

        // Selecionar primeiro módulo automaticamente
        if (this.modules.length > 0 && !this.selectedModule) {
          this.selectModule(this.modules[0]);
        }
      } catch (error) {
        console.error("Erro ao carregar módulos:", error);
        this.$bvToast.toast("Erro ao carregar módulos", {
          title: "Erro",
          toastClass: "custom-toast custom-toast-error",
          variant: "light",
          solid: true,
          autoHideDelay: 10000,
          noCloseButton: false,
        });
      } finally {
        this.modulesLoading = false;
      }
    },

    selectModule(module) {
      this.selectedModule = module;
      this.loadContents(module._id);
    },

    openModuleModal(module = null) {
      this.editingModule = module;
      if (module) {
        this.moduleForm = {
          titulo: module.titulo,
          descricao: module.descricao,
          ordem: module.ordem,
          isExam: module.isExam || false,
          examId: module.examId || null,
        };
      }
      this.moduleModalVisible = true;
    },

    async saveModule(evt) {
      evt.preventDefault();
      this.loading = true;

      try {
        const data = {
          ...this.moduleForm,
          courseId: this.courseId,
        };

        if (this.editingModule) {
          await updateModule(this.editingModule._id, data);
          this.$bvToast.toast("Módulo atualizado com sucesso!", {
            title: "Sucesso",
            toastClass: "custom-toast custom-toast-success",
            variant: "light",
            solid: true,
            autoHideDelay: 5000,
            noCloseButton: false,
          });
        } else {
          await createModule(data);
          this.$bvToast.toast("Módulo criado com sucesso!", {
            title: "Sucesso",
            toastClass: "custom-toast custom-toast-success",
            variant: "light",
            solid: true,
            autoHideDelay: 5000,
            noCloseButton: false,
          });
        }

        this.moduleModalVisible = false;
        await this.loadModules();
      } catch (error) {
        console.error("Erro ao salvar módulo:", error);
        this.$bvToast.toast("Erro ao salvar módulo", {
          title: "Erro",
          toastClass: "custom-toast custom-toast-error",
          variant: "light",
          solid: true,
          autoHideDelay: 10000,
          noCloseButton: false,
        });
      } finally {
        this.loading = false;
      }
    },

    confirmDeleteModule(module) {
      this.$bvModal
        .msgBoxConfirm(
          `Tem certeza que deseja deletar o módulo "${module.titulo}"? Todos os conteúdos serão perdidos.`,
          {
            title: "Confirmar Exclusão",
            size: "md",
            buttonSize: "sm",
            okVariant: "danger",
            okTitle: "Sim, deletar",
            cancelTitle: "Cancelar",
            centered: true,
          }
        )
        .then((value) => {
          if (value) {
            this.deleteModuleConfirmed(module._id);
          }
        });
    },

    async deleteModuleConfirmed(moduleId) {
      this.loading = true;
      try {
        await deleteModule(moduleId);
        this.$bvToast.toast("Módulo deletado com sucesso!", {
          title: "Sucesso",
          toastClass: "custom-toast custom-toast-success",
          variant: "light",
          solid: true,
          autoHideDelay: 5000,
          noCloseButton: false,
        });

        if (this.selectedModule && this.selectedModule._id === moduleId) {
          this.selectedModule = null;
          this.contents = [];
        }

        await this.loadModules();
      } catch (error) {
        console.error("Erro ao deletar módulo:", error);
        this.$bvToast.toast("Erro ao deletar módulo", {
          title: "Erro",
          toastClass: "custom-toast custom-toast-error",
          variant: "light",
          solid: true,
          autoHideDelay: 10000,
          noCloseButton: false,
        });
      } finally {
        this.loading = false;
      }
    },

    resetModuleForm() {
      this.moduleForm = {
        titulo: "",
        descricao: "",
        ordem: null,
        isExam: false,
        examId: null,
      };
      this.editingModule = null;
    },

    // ==================== CONTEÚDOS ====================

    async loadContents(moduleId) {
      this.contentsLoading = true;
      try {
        const response = await getContents(moduleId);
        this.contents = response.data || [];
      } catch (error) {
        console.error("Erro ao carregar conteúdos:", error);
        this.$bvToast.toast("Erro ao carregar conteúdos", {
          title: "Erro",
          toastClass: "custom-toast custom-toast-error",
          variant: "light",
          solid: true,
          autoHideDelay: 10000,
          noCloseButton: false,
        });
      } finally {
        this.contentsLoading = false;
      }
    },

    openContentModal(content = null) {
      this.editingContent = content;
      if (content) {
        this.contentForm = {
          tipo: content.tipo,
          titulo: content.titulo,
          descricao: content.descricao,
          videoId: content.videoId || "",
          url: content.url,
          conteudo: content.conteudo,
          duracao: content.duracao,
          ordem: content.ordem,
          quizId: content.quizId || null,
        };
      }
      this.contentModalVisible = true;
    },

    async saveContent(evt) {
      evt.preventDefault();
      this.loading = true;

      try {
        const data = {
          ...this.buildContentPayload(),
          moduleId: this.selectedModule._id,
        };

        if (this.editingContent) {
          await updateContent(this.editingContent._id, data);
          this.$bvToast.toast("Conteúdo atualizado com sucesso!", {
            title: "Sucesso",
            toastClass: "custom-toast custom-toast-success",
            variant: "light",
            solid: true,
            autoHideDelay: 5000,
            noCloseButton: false,
          });
        } else {
          await createContent(data);
          this.$bvToast.toast("Conteúdo criado com sucesso!", {
            title: "Sucesso",
            toastClass: "custom-toast custom-toast-success",
            variant: "light",
            solid: true,
            autoHideDelay: 5000,
            noCloseButton: false,
          });
        }

        this.contentModalVisible = false;
        await this.loadContents(this.selectedModule._id);
      } catch (error) {
        console.error("Erro ao salvar conteúdo:", error);
        this.$bvToast.toast("Erro ao salvar conteúdo", {
          title: "Erro",
          toastClass: "custom-toast custom-toast-error",
          variant: "light",
          solid: true,
          autoHideDelay: 10000,
          noCloseButton: false,
        });
      } finally {
        this.loading = false;
      }
    },

    confirmDeleteContent(content) {
      this.$bvModal
        .msgBoxConfirm(
          `Tem certeza que deseja deletar o conteúdo "${content.titulo}"?`,
          {
            title: "Confirmar Exclusão",
            size: "md",
            buttonSize: "sm",
            okVariant: "danger",
            okTitle: "Sim, deletar",
            cancelTitle: "Cancelar",
            centered: true,
          }
        )
        .then((value) => {
          if (value) {
            this.deleteContentConfirmed(content._id);
          }
        });
    },

    async deleteContentConfirmed(contentId) {
      this.loading = true;
      try {
        await deleteContent(contentId);
        this.$bvToast.toast("Conteúdo deletado com sucesso!", {
          title: "Sucesso",
          toastClass: "custom-toast custom-toast-success",
          variant: "light",
          solid: true,
          autoHideDelay: 5000,
          noCloseButton: false,
        });
        await this.loadContents(this.selectedModule._id);
      } catch (error) {
        console.error("Erro ao deletar conteúdo:", error);
        this.$bvToast.toast("Erro ao deletar conteúdo", {
          title: "Erro",
          toastClass: "custom-toast custom-toast-error",
          variant: "light",
          solid: true,
          autoHideDelay: 10000,
          noCloseButton: false,
        });
      } finally {
        this.loading = false;
      }
    },

    resetContentForm() {
      this.contentForm = {
        tipo: "Vídeo",
        titulo: "",
        descricao: "",
        videoId: "",
        url: "",
        conteudo: "",
        duracao: "",
        ordem: null,
        quizId: null,
      };
      this.editingContent = null;
    },

    handleContentTypeChange(tipo) {
      if (tipo === "Vídeo") {
        this.contentForm.url = "";
        this.contentForm.conteudo = "";
        this.contentForm.quizId = null;
        return;
      }

      this.contentForm.videoId = "";

      if (tipo !== "Texto") {
        this.contentForm.conteudo = "";
      }

      if (tipo !== "Quiz") {
        this.contentForm.quizId = null;
      }
    },

    buildContentPayload() {
      const payload = {
        tipo: this.contentForm.tipo,
        titulo: this.contentForm.titulo,
        descricao: this.contentForm.descricao,
        duracao: this.contentForm.duracao,
        ordem: this.contentForm.ordem,
      };

      if (this.contentForm.tipo === "Vídeo") {
        return {
          ...payload,
          videoId: (this.contentForm.videoId || "").trim(),
          url: "",
          conteudo: "",
          quizId: null,
        };
      }

      if (this.contentForm.tipo === "Texto") {
        return {
          ...payload,
          videoId: "",
          url: "",
          conteudo: this.contentForm.conteudo,
          quizId: null,
        };
      }

      if (this.contentForm.tipo === "Quiz") {
        return {
          ...payload,
          videoId: "",
          url: "",
          conteudo: "",
          quizId: this.contentForm.quizId,
        };
      }

      return {
        ...payload,
        videoId: "",
        url: (this.contentForm.url || "").trim(),
        conteudo: "",
        quizId: null,
      };
    },

    getContentTypeIcon(tipo) {
      const icons = {
        Vídeo: "fa fa-play-circle",
        Texto: "fa fa-file-text",
        Quiz: "fa fa-question-circle",
        Material: "fa fa-file",
        PDF: "fa fa-file-pdf-o",
        Link: "fa fa-link",
      };
      return icons[tipo] || "fa fa-file";
    },

    getContentTypeVariant(tipo) {
      const variants = {
        Vídeo: "primary",
        Texto: "success",
        Quiz: "warning",
        Material: "info",
        PDF: "danger",
        Link: "secondary",
      };
      return variants[tipo] || "secondary";
    },

    getUrlDescription() {
      const descriptions = {
        PDF: "URL do arquivo PDF",
        Material: "URL do material de apoio",
        Link: "URL do link externo",
      };
      return descriptions[this.contentForm.tipo] || "URL opcional";
    },

    getUrlPlaceholder() {
      const placeholders = {
        PDF: "https://exemplo.com/documento.pdf",
        Material: "https://exemplo.com/material.zip",
        Link: "https://exemplo.com",
      };
      return placeholders[this.contentForm.tipo] || "https://...";
    },

    contentRowClass(item) {
      if (!item) return "";
      return "content-row";
    },

    // ==================== QUIZZES E PROVAS ====================

    async loadQuizzes() {
      try {
        const response = await getAllQuizzes();
        this.quizzes = response.data || [];
      } catch (error) {
        console.error("Erro ao carregar quizzes:", error);
      }
    },

    async loadExams() {
      try {
        const response = await getAllExams();
        this.exams = response.data || [];
      } catch (error) {
        console.error("Erro ao carregar provas:", error);
      }
    },
  },
};
</script>

<style scoped>
/* Layout de 2 colunas */
.module-column,
.content-column {
  min-height: 600px;
  max-height: 600px;
  overflow-y: auto;
}

.module-list,
.content-list {
  padding: 1rem;
}

/* Estilo dos itens de módulo */
.module-item {
  padding: 1rem;
  margin-bottom: 0.5rem;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  background-color: #fff;
}

.module-item:hover {
  border-color: #007bff;
  box-shadow: 0 2px 8px rgba(0, 123, 255, 0.15);
  transform: translateX(4px);
}

.module-item.active {
  border-color: #007bff;
  border-left: 4px solid #007bff;
  background-color: #e7f3ff;
  box-shadow: 0 2px 8px rgba(0, 123, 255, 0.2);
}

.module-content {
  position: relative;
}

.module-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
}

.module-badge {
  font-size: 0.85rem;
  padding: 0.35rem 0.6rem;
}

.module-title {
  font-size: 1rem;
  color: #2c3e50;
}

.module-description {
  font-size: 0.875rem;
  color: #6c757d;
  margin-bottom: 0.5rem;
}

.module-actions {
  display: flex;
  gap: 0.25rem;
  margin-top: 0.5rem;
}

/* Scrollbar personalizado */
.module-column::-webkit-scrollbar,
.content-column::-webkit-scrollbar {
  width: 8px;
}

.module-column::-webkit-scrollbar-track,
.content-column::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.module-column::-webkit-scrollbar-thumb,
.content-column::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

.module-column::-webkit-scrollbar-thumb:hover,
.content-column::-webkit-scrollbar-thumb:hover {
  background: #555;
}

/* Tabs */
::v-deep .nav-tabs .nav-link {
  font-weight: 500;
}

::v-deep .nav-tabs .nav-link.active {
  color: #007bff;
  border-bottom: 2px solid #007bff;
}

/* Tabela de conteúdos - Estilo igual à tabela de denúncias */
.contents-table {
  background-color: #fff;
}

::v-deep .contents-header th {
  background-color: #fff !important;
  font-weight: 600;
  color: #73818f;
  font-size: 0.75rem;
  text-transform: uppercase;
  border-top: 1px solid #c8ced3;
  border-bottom: 1px solid #c8ced3;
  white-space: nowrap;
  padding: 0.75rem;
}

::v-deep .content-row {
  cursor: pointer;
  transition: background-color 0.15s ease-in-out;
  background-color: #fff;
}

::v-deep .content-row:nth-of-type(odd) {
  background-color: #f0f3f5;
}

::v-deep .content-row:hover {
  background-color: #e4e7ea !important;
}

::v-deep .content-row td {
  border-top: 1px solid #c8ced3;
  vertical-align: middle;
  padding: 0.75rem;
  color: #23282c;
}

::v-deep .content-title {
  color: #20a8d8;
  font-weight: 400;
}

::v-deep .duration-text {
  color: #23282c;
}

::v-deep .action-btn {
  padding: 0.25rem 0.5rem;
}

::v-deep .action-icon {
  color: #73818f;
  transition: color 0.2s;
  font-size: 1rem;
}

::v-deep .content-row:hover .action-icon {
  color: #20a8d8;
}

::v-deep .action-icon.text-danger:hover {
  color: #f86c6b !important;
}

::v-deep .ordem-badge {
  font-size: 0.75rem;
  padding: 0.25rem 0.5rem;
  font-weight: 600;
}

::v-deep .tipo-badge {
  font-size: 0.75rem;
  font-weight: 600;
  padding: 0.25rem 0.5rem;
}

/* Tabela de conteúdos */
::v-deep .table td {
  vertical-align: middle;
}

/* Botões nos modais */
::v-deep .modal-footer .btn {
  min-width: 80px;
}
</style>
